/**
 * Anchor navigation has to go through Lenis, otherwise the native jump and the
 * smooth loop fight each other. Falls back to native when Lenis is absent
 * (reduced motion).
 */
/* -56px clears the fixed top bar. */
export function scrollToSection(id, { offset = -56 } = {}) {
  const target = id === "top" ? 0 : `#${id}`;

  if (window.lenis) {
    window.lenis.scrollTo(target, { offset, duration: 1.4 });
    return;
  }

  if (target === 0) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const el = document.querySelector(target);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}
